class IntegrationRecordObject {
  constructor(data) {
    Object.assign(this, data);
  }
}

export default IntegrationRecordObject;
